<template>
  <div class="advanced-setting">
    <AppScrollbar style="height: 100%">
      <div class="setting-main">
        <el-form size="mini" label-position="top" label-width="80px" label-suffix="：">
          <el-form-item label="审批同意或办理时是否签字">
            <el-switch inactive-text="无需签字" active-text="需要签字"
                       v-model="setting.sign"></el-switch>
            <div class="sign-tip">如果此处设置为 <b>需要签字</b>，则所有审批人"同意"或办理时 <b>必须签字</b></div>
          </el-form-item>
          <el-form-item label="审批同意或办理时填写表单">
            <ApprovalFormConfig v-model="setting.formJson" />
            <div class="sign-tip">如果此处配置了 <b>审批表单</b>，则所有审批人"同意"或办理时 <b>必须填写</b></div>
          </el-form-item>
          <el-form-item label="流程操作配置">
            <div class="action-groups-wrap">
            <div v-for="group in actionGroups"
                 :key="group.key"
                 class="action-group">
              <div class="group-label">{{ group.label }}</div>
              <div class="action-options">
                <div v-for="action in group.options"
                     :key="action.key"
                     class="action-item">
                  <el-checkbox v-model="setting.actions[action.key]">
                    {{ action.label }}
                  </el-checkbox>
                  <el-tooltip :content="action.desc"
                              placement="top"
                              effect="dark">
                    <i class="el-icon-question action-tip"></i>
                  </el-tooltip>
                </div>
              </div>
            </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </AppScrollbar>
  </div>
</template>

<script>
import AppScrollbar from '../../AppScrollbar'
import ApprovalFormConfig from '../process/common/ApprovalFormConfig'
export default {
  name: 'AdvancedSetting',
  inject: ['$workflow'],
  components: {
    AppScrollbar,
    ApprovalFormConfig
  },
  computed: {
    setting () {
      return this.$workflow.design.setting
    }
  },
  data () {
    return {
      actionGroups: [
        {
          key: 'initiator',
          label: '发起人',
          options: [
            { key: 'initiatorUrge', label: '催办', desc: '对于时效要求高的流程，发起人可催办提醒当前节点处理人，一般以消息通知方式提醒处理人' },
            { key: 'initiatorComment', label: '评论', desc: '发起人可以在流程中添加评论信息' }
          ]
        },
        {
          key: 'cc',
          label: '抄送人',
          options: [
            { key: 'ccUrge', label: '催办', desc: '抄送人可催办提醒当前节点处理人，一般以消息通知方式提醒处理人' },
            { key: 'ccComment', label: '评论', desc: '抄送人可以在流程中添加评论信息' }
          ]
        },
        {
          key: 'approver',
          label: '审核人/办理人',
          options: [
            { key: 'approverUrge', label: '催办', desc: '仅对已处理且未结束的流程有效，审核人可催办提醒后续节点处理人' },
            { key: 'approverComment', label: '评论', desc: '当前节点处理人可以添加评论信息', defaultVal: true },
            { key: 'approverTransfer', label: '转办', desc: '当前节点处理人，将操作权限转给别人处理，处理完后进入下一节点（自己不再处理）' },
            { key: 'approverDelegate', label: '委派', desc: '当前节点处理人，将自己的主办或者经办权限转移委托至别的用户代为处理，处理完后回到当前处理人手中，并由当前处理人处理完后进入下一节点' },
            { key: 'approverAddMulti', label: '加签', desc: '当前节点处理人，需要让其他人核对流程' }
          ]
        }
      ]
    }
  },
  methods: {
    validate () {
      return []
    },
    initActions () {
      if (!this.setting.actions) {
        this.$set(this.setting, 'actions', {})
      }
      this.actionGroups.forEach(group => {
        group.options.forEach(action => {
          if (this.setting.actions[action.key] === undefined) {
            this.$set(this.setting.actions, action.key, action.defaultVal === true)
          }
        })
      })
    }
  },
  watch: {
    setting: {
      handler () {
        this.initActions()
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .advanced-setting {
    height: 100%;

    .setting-main {
      width: 540px;
      margin: auto;
      padding: 30px 15px;

      .sign-tip {
        margin-top: 4px;
        color: #949495;
        font-size: small;
      }

      .action-groups-wrap {
        border: 1px solid #dcdfe6;
        background-color: #F3F5F7;
        border-radius: 6px;
        padding: 16px;
      }

      .action-group {
        &:not(:first-child) {
          margin-top: 16px;
        }

        .group-label {
          font-size: 13px;
          color: #606266;
          font-weight: 500;
        }

        .action-options {
          display: flex;
          flex-wrap: wrap;
          gap: 6px 20px;
          padding-left: 12px;

          .action-item {
            display: flex;
            align-items: center;
            min-width: 90px;

            ::v-deep .el-checkbox__label {
              font-size: 13px;
            }

            .action-tip {
              margin-left: 4px;
              color: #909399;
              cursor: help;
              &:hover {
                color: #409eff;
              }
            }
          }
        }
      }
    }
  }
</style>
